import { useEffect, useState } from 'react';
import _ from 'lodash';
import useFetch from 'use-http';
import moment from 'moment';
import { API } from 'common/constants/api-urls';
import { DAYS_PARAM } from 'common/constants/constants';
import { metricNames } from '@linearb/linjs-common';
import { convertMetricsNameToV3 } from 'common/services/metrics.service';

const DEFAULTS = {
  SINCE_LAST_X_DAYS: 30,
  METRICS_POINTS_LENGTH: 5,
  REQUESTED_METRICS: [metricNames.CYCLE_TIME]
};

const useServiceMetricsSince = (
  service,
  {
    requestedMetrics = DEFAULTS.REQUESTED_METRICS,
    sinceLastXDays = DEFAULTS.SINCE_LAST_X_DAYS
  } = {}
) => {
  const [serviceMetrics, setServiceMetrics] = useState(null);
  const { error, loading, post } = useFetch(API.METRICS_SEARCH_PATH_V3);

  const createdAt = _.get(service, 'created_at');
  const isPending = moment(createdAt).add({ [DAYS_PARAM]: 1 }) > moment();

  const getRequestPayload = () => {
    const serviceId = _.get(service, 'id');
    const startDate = moment()
      .subtract(sinceLastXDays, DAYS_PARAM)
      .format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');
    return {
      group_by: 'organization',
      limit: 1,
      offset: 0,
      requested_metrics: convertMetricsNameToV3(requestedMetrics),
      return_no_data: true,
      roll_up: '1d',
      service_ids: [serviceId],
      time_ranges: [{ before: endDate, after: startDate }]
    };
  };

  const fetchServiceMetrics = async () => {
    const requestPayload = getRequestPayload();
    const response = await post('', requestPayload);
    const metrics = _.get(response, '[0].data', []);
    setServiceMetrics(metrics);
  };
  useEffect(() => {
    if (!isPending) fetchServiceMetrics();
  }, []);

  return {
    data: serviceMetrics,
    loading,
    error,
    isPending
  };
};

export default useServiceMetricsSince;
